import { Typography } from "antd";
import { TitleProps } from "antd/es/typography/Title";
import { HTMLAttributes, ReactElement } from "react";

import classes from "./LoginFormLayout.module.css";

const { Text, Title } = Typography;

interface LoginFormLayoutProps extends HTMLAttributes<HTMLDivElement> {
  showSupportText?: boolean;
  name?: string;
  titleProps?: TitleProps;
  childrenContainerClassName?: string;
}

export function LoginFormLayout(props: LoginFormLayoutProps): ReactElement {
  const {
    className,
    showSupportText = true,
    children,
    name,
    titleProps,
    childrenContainerClassName,
    ...restProps
  } = props;
  const concatTitleClassName = `${classes.wrapper} ${className || ""}`;
  const concatChildrenContainerClassName = `${classes.container} ${childrenContainerClassName || ""}`;

  return (
    <div {...restProps} className={concatTitleClassName}>
      {name && (
        <Title
          {...titleProps}
          className={`${classes.header} ${titleProps?.className}`}
          level={titleProps?.level ? 1 : titleProps?.level}
        >
          {name}
        </Title>
      )}

      <div className={concatChildrenContainerClassName}>{children}</div>

      {showSupportText && (
        <Text className={classes.supportText}>
          {
            "По всем возникшим трудностям и вопросам вы можете обратиться в техподдержку по адресу "
          }
          <a href={`mailto:${process.env.REACT_APP_IT_ONLINE_MAIL}`}>
            {process.env.REACT_APP_IT_ONLINE_MAIL}
          </a>
        </Text>
      )}
    </div>
  );
}
